import api from "./api";

// Klipy GIF helpers — all traffic goes through the BlinkLink backend proxy.
// The Klipy API key lives ONLY on the server; nothing here ever sees it.

export async function fetchTrendingGifs(page = 1, perPage = 24) {
  const { data } = await api.get("/gifs/trending", { params: { page, per_page: perPage } });
  return data; // { gifs, page, per_page, has_next, content_filter }
}

export async function searchGifs(q, page = 1, perPage = 24) {
  const { data } = await api.get("/gifs/search", { params: { q, page, per_page: perPage } });
  return data;
}

// Fire-and-forget Klipy analytics. Never blocks or throws into the UI.
export function registerGifShare(gif) {
  if (!gif) return;
  api
    .post("/gifs/register-share", { gif_slug: gif.gif_slug, gif_id: gif.gif_id })
    .catch(() => {});
}
